import { render, staticRenderFns } from "./ExploreSidebar.vue?vue&type=template&id=4c868e12&"
import script from "./ExploreSidebar.vue?vue&type=script&lang=js&"
export * from "./ExploreSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports